import { useEffect } from "react";
import { useNavigate } from "react-router-dom";

import { Grid, Card, Button, CardContent, Typography, useTheme } from "@mui/material";

import { pathRoute } from "../../../Utils/Routes/routes";

export default function ConfirmationPasswordReseted() {
  const navigate = useNavigate();
  const theme = useTheme();
  useEffect(() => {
    const time = setTimeout(() => {
      navigate(pathRoute.SignIn.Index, {
        replace: true,
      });
    }, 5000);
    return () => clearTimeout(time);
  }, []);

  return (
    <Card sx={{ backgroundColor: theme.palette.background.paper }}>
      <CardContent>
        <Grid container flexDirection="column" alignItems="center">
          <Typography gutterBottom variant="h5" component="h2">
            You have successfully changed your password
          </Typography>
          <Button
            sx={{ mt: 2 }}
            color="primary"
            onClick={() => {
              navigate(pathRoute.SignIn.Index, {
                replace: true,
              });
            }}
            variant="contained"
          >
            Continue
          </Button>
        </Grid>
      </CardContent>
    </Card>
  );
}
